export const SESSION_TOKEN = 'session-token'
export const PAYMENT_TOKEN = 'payment-token'
